// Single Article Detail 

<template>
	<div class="art-detail" v-if="ok">

		<div class="sub-heading">
			{{ rec.cat.title }}
			<span style="float:right">{{rec.dateVis}}</span>
		</div>

		<div class="sub-heading">
			Submitted by: {{ rec.credit }}
		</div>	

		<div class="detail-content">
			<div v-if="contentType=='story'" class="main-text" v-html="fullTxt"></div>
			<div v-else class="pic-frame" ref="pic-frame">
				<img class="main-pic" :src="pic.imgUrl" @load="mainPicLoaded" />
			</div>
		</div>

		<div class="v-spacer" />

		<div class="thm-list">
			<!-- First frame = bubble -->
			<div class="thm-frame narrow active" ref="bub" @click="clickShowStory($event)">
				<UniIcon ico="talk_bub" fit="1" />
			</div>

			<!-- Next bubbles: thumbs -->
			<span v-for="(item, idx) in current.pix.slice(0,3)" :key="idx" >
				<span class="h-spacer"></span>
				<div class="thm-frame" ref="thumbs" @click="clickShowPic($event, item)" >
					<img class="thm-pic" :src="item.thmUrl" />
				</div>
			</span>

		</div>

		<!-- Stops animation blocking of thumbs -->
		<img class="thm-pic" src="img/blank.png" width="10" height="10" />


	</div>
</template>

<script>
import { m } from "@/utils/utils";
import { eventBus } from '@/main';
import { mapState } from 'vuex';
import * as Utils from '@/utils/utils';

export default {
	data() {
		return {
			rec: {},
			ok: false,
			fullTxt: "",
			contentType: 'story',
			pic: {},
		}
	},
	computed: {
		...mapState('app', ['current']),
	},
	methods: {
		mainPicLoaded(evt) {
			// eventBus.$emit('widget', 'wait', false);
			m("main pic loaded", evt.target);
			this.mainPicDecorate();

		},
		mainPicDecorate() {
			m("main pic decorate");
			// Scale down
			const target = this.$refs["pic-frame"];
			target.className = "pic-frame";
			setTimeout(() => {
				target.className = "pic-frame effect2";
			}, 200);

			// Set feather frame
			// const mainPic = this.$refs["main-pic"];
			// const w = mainPic.clientWidth;
			// const h = mainPic.clientHeight;
			// m(w,h);
			// const featherFrame = this.$refs["feather-frame"];
			// featherFrame.style.width = w + 'px';
			// featherFrame.style.height = h + 'px';
			
			// const half =  w*.5;
			// featherFrame.style.left = "calc(50% - " + half + "px)";

		},
		clickShowStory(evt) {
			m("click show story beg");
			this.setActive(evt.target);
			this.contentType = 'story';
			m("click show story end");
		},

		clickShowPic(evt, item) {
			m("click show pic beg", item);

			const target = this.$refs["pic-frame"];
			if (target) target.className = "pic-frame";

			this.setActive(evt.target);
			this.pic =  {}; // Empty pic
			this.contentType = 'pic';
			
			// Patch: wait after refresh empty pic to insert new pic
			setTimeout(() => {
				this.pic =  item;
			}, 100);

			m("click show pic end");

		},

		setActive(node) {
			m("set active node beg");
			let refs = [...this.$refs.thumbs] || [];
			refs.push(this.$refs.bub);
			m("refs", refs);

			// Turn off all
			for (let div of refs) {
				div.className = div.className.replace(/(active)/gm,'');
			}	

			// Turn on active
			const actual_node = (node.className.indexOf("thm-frame")>=0)? node: node.parentElement;
			actual_node.className += " active";

			m("set active node end");
		},
		
		// Replace line feeds with br ==========
		addBreaks(str1) {
			const str2 = str1 || "";
			return str2.replace(/(\r\n|\n|\r)/gm,'<br/>');
		},
	},
	created() {
		m("det created", this.current); 
		this.rec = {...this.current.art};
		if (this.rec.fullTxt) {
			this.ok = true;
			this.fullTxt = Utils.break2Br(this.rec.fullTxt);
		}
		m("ok", this.ok);
		m(this.rec);
	},
	mounted() {
		m("art detail mounted");
		this.$store.dispatch('app/reqArtPix');
	},
}
</script>

<style scoped>

.art-detail {
	height: 100%;
	overflow: hidden;
	background-color: #F9F6F3;
	padding: 10px;
	font-size: 15px;
	border: solid 0px #999;
}

.sub-heading {
	height: 30px;
	overflow: hidden;
	color: #630;
	overflow: hidden;
	white-space: nowrap;
	border: solid 0px #999;
}
	
.detail-content {
	/* position: relative; */
	height: calc(100% - 190px);
	max-width: 502px;
	overflow: hidden;
	margin: 0 auto;
	/* text-align: center; */
	/* padding: 0px; */
	/* background-color: #F6F6F6; */
	border-radius:10px;
	border: 1px solid #CB9;		
}

.main-text {
	width: 100%;
	height: 100%;
	overflow-y: auto;
	text-align:justify;
	padding: 10px;
	border: solid 0px #F00;
}

.pic-frame {
	position: relative;
	width: 104%;
	height: 104%;
	overflow: hidden;
	text-align: center;

	left: -2%;
	top: -2%;

	opacity: 0;
	/* border: solid 1px #F9F6F3;		 */
	border: solid 0px #f00;		
}

.effect1 {
	transition: all 1s ease, opacity 1s ease;
    transform: scale(.961);
	opacity: 1;
}

.effect2 {
	opacity: 1;
	transition: opacity 1s ease;
	animation-name: fadein;
	animation-duration: 6s;
	animation-fill-mode: forwards;
}

@keyframes fadein {
	from {
		transform: scale(1.04);
	}
	to {
	    transform: scale(.961);
	}
}



.feather-frameNOTUSEDYET {
	position:absolute;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	box-shadow: inset 0 0 3px 3px #F9F6F3;
	border-radius: 7px;
	border: solid 0px #090;		
}

.main-pic {
	/* width: 100%; */
	/* height: 100%; */
	max-width: 100%;
	max-height: 100%;
	/* overflow: hidden; */
	border-radius: 8px;

	border: solid 0px #090;
}

.thm-list {
	width: 292px;
	height: 110px;
	margin: auto;
	overflow: hidden;
	background-color: #EEE3D6;
	padding: 5px 0px 0px 5px;
	border-radius: 10px;
	border: solid 1px #CB9;
}

.thm-frame {
	float: left;		
	width: 72px;
	height:96px;
	overflow: hidden;
	cursor: pointer;
	padding: 0px 0px 0px 0px;
	background-color:transparent;
	border-radius:6px;
	border: solid 1px #999;
}

.narrow {
	width: 50px;
}

.active  {
	background-color: #FFF;
}

/* Center img inside frame, might be smaller/larger than frame */
.thm-pic {
	display:inline-block;
	position: relative;
	top: 50%;
	left: 50%;
	-webkit-transform: translateX(-50%) translateY(-50%);
	-moz-transform: translateX(-50%) translateY(-50%);
	-ms-transform: translateX(-50%) translateY(-50%);
	-o-transform: translateX(-50%) translateY(-50%);
	transform: translateX(-50%) translateY(-50%);
	border: solid 0px #C30;
}

.v-spacer {
	width: 10px;
	height: 10px;
	border: solid 0px #C30;
}

.h-spacer {
	float: left; 
	width: 4px;
	height: 10px;
	border: solid 0px #C30;
}

</style>
